var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDailyPulseLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 8.75L1 8.95",
  stroke: "#4585FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 10.45L1 15.25",
  stroke: "#4585FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.75 5.44998L3.75 5.64998",
  stroke: "#4585FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.75 7.14996L3.75 18.55",
  stroke: "#4585FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 7.04999L6.5 15.25",
  stroke: "#4585FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 16.75L6.5 16.95",
  stroke: "#4585FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M9.25 10.2L9.25 13.8",
  stroke: "#4585FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M12 6.94998L12 7.14998",
  stroke: "#4585FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M12 8.64996L12 17.05",
  stroke: "#4585FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M14.75 9.75L14.75 12.55",
  stroke: "#4585FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M14.75 14.05L14.75 14.25",
  stroke: "#4585FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 7.85001L17.5 8.05001",
  stroke: "#4585FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 9.55005L17.5 16.15",
  stroke: "#4585FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M20.25 4.60001L20.25 4.80001",
  stroke: "#4585FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M20.25 6.30005L20.25 19.4",
  stroke: "#4585FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M23 14.95L23 14.75",
  stroke: "#4585FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M23 13.25L23 9.05",
  stroke: "#4585FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})));
export default SvgDailyPulseLogo;